var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#5AA0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7799 15.2201C45.74 18.1803 45.74 22.9797 42.7799 25.9399L40.0999 28.6198C37.4223 31.2975 33.2398 31.553 30.2749 29.3866L28.3866 31.2749C30.553 34.2398 30.2975 38.4223 27.6198 41.0999L24.9399 43.7799C21.9797 46.74 17.1803 46.74 14.2201 43.7799C11.26 40.8197 11.26 36.0203 14.2201 33.0601L16.9001 30.3802C19.534 27.7462 23.624 27.4559 26.5789 29.5093L28.5093 27.5789C26.4559 24.624 26.7462 20.534 29.3802 17.9001L32.0601 15.2201C35.0203 12.26 39.8197 12.26 42.7799 15.2201ZM24.748 31.3402C22.8207 30.2489 20.3291 30.5244 18.6867 32.1668L16.0068 34.8467C14.0333 36.8202 14.0333 40.0198 16.0068 41.9932C17.9802 43.9667 21.1798 43.9667 23.1533 41.9932L25.8332 39.3133C27.5207 37.6258 27.7652 35.0419 26.5669 33.0946L22.4504 37.211C21.957 37.7044 21.1571 37.7044 20.6638 37.211C20.1704 36.7177 20.1704 35.9178 20.6638 35.4244L24.748 31.3402ZM38.3133 26.8332C36.6258 28.5207 34.0419 28.7652 32.0946 27.5669L34.9568 24.7046C35.4502 24.2113 35.4502 23.4114 34.9568 22.918C34.4634 22.4247 33.6635 22.4247 33.1702 22.918L30.3402 25.748C29.2489 23.8207 29.5244 21.3291 31.1668 19.6867L33.8467 17.0068C35.8202 15.0333 39.0198 15.0333 40.9932 17.0068C42.9667 18.9802 42.9667 22.1798 40.9932 24.1533L38.3133 26.8332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a8a08ca0d09a89e7d23567f19b05c56f.svg";
export { ForwardRef as ReactComponent };